<template>
  <div v-if="isHomePage">
    <div class="row">
      <div v-if="!isWetSignature" class="col-12 col-md-4 gt-sm">
        <ProgressSteps :step="step"></ProgressSteps>
      </div>
      <div :class="isWetSignature ? 'col-12 col-md-12' : 'col-12 col-md-8'">
        <div class="bg-white q-mx-md-md">
          <div class="header" v-if="!primaryImage">
            <img src="/assets/icons/header-logo.svg" class="header-logo" />
          </div>
          <div
            v-else
            :style="{
              backgroundImage: 'url(' + primaryImage + ')',
              height: '330px',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }"
          ></div>
          <div class="q-px-lg q-py-sm">
            <br />
            <MainHeadline align="center" :header="headerText" :body="bodyText" :secondBody="secondBody" />
            <hr />
          </div>
          <div class="q-px-lg q-pt-sm">
            <ProgressList v-if="isWetSignature" :approvals="approvalsStatus()" />
            <ProgressList v-else :approvals="approvalsStatus()" :reviewSignContrct="reviewSignContrctStatus()" />
          </div>
          <div v-if="isWetSignature" class="q-px-lg q-py-lg" style="text-align: center">
            <QBtn
              v-if="currentStatus && (currentStatus == 'reviewAndSignContract' || currentStatus == 'finished')"
              color="primary"
              no-caps
              :to="{ name: 'logout' }"
              >Log Out</QBtn
            >
            <QBtn v-else color="primary" class="full-width" no-caps @click="onClickHandler()" :loading="loading">Proceed</QBtn>
          </div>
          <div v-if="!isWetSignature" class="q-px-lg q-py-lg" style="text-align: center">
            <QBtn v-if="currentStatus && currentStatus == 'finished'" color="primary" no-caps :to="{ name: 'logout' }">Log Out</QBtn>
            <QBtn v-else color="primary" class="full-width" no-caps @click="onClickHandler()" :loading="loading">Proceed</QBtn>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>

<script>
import { QBtn } from 'quasar';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import ProgressList from '../../components/Molecules/ProgressList';
import MainHeadline from '../../components/Atoms/MainHeadline';
import { mapState, mapGetters } from 'vuex';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';

export default {
  name: 'Home',
  mixins: [MyCustomFunctions],
  computed: {
    ...mapState({
      applicationId: (state) => (state.vehicleApplication ? state.vehicleApplication?.vehicleApplication?.applicationId : null),
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null,
      user: (state) => state.auth.user
    }),
    ...mapGetters({
      isWetSignature: 'vehicleApplication/isWetSignature',
      orgProfile: 'theme/getScoreboard',
      calculatorApplicant: 'vehicleApplication/isCalculatorApplicant'
    }),
    isCalculatorApplicant() {
      return this.calculatorApplicant;
    },
    primaryImage() {
      if (this.orgProfile?.primaryImage) {
        return this.orgProfile.primaryImage;
      } else {
        return null;
      }
    },
    currentStatus() {
      return this.scoreboard?.statusSecondary ? this.scoreboard?.statusSecondary : null;
    },
    headerText() {
      if (this.currentStatus == 'finished') return 'Congratulations!';
      else if (this.currentStatus == 'approvals' || this.currentStatus == 'reviewAndSignContract') return 'Application in progress';
      else return `Welcome ${this.capitalizeFirstLetter(this.user.firstName)}!`;
    },
    bodyText() {
      if (this.currentStatus == 'finished')
        return 'Your application is complete and we will contact you shortly about the delivery of your vehicle.';
      else if (this.currentStatus == 'approvals' || this.currentStatus == 'reviewAndSignContract')
        return 'Thanks for checking in, the application is currently in progress.';
      else {
        if (this.isWetSignature)
          return 'You have been nominated as an Authorised Officer to sign the lease documentation for the quote below. First, please complete your identity verification.';
        else return 'Your account gives you access to step through the following steps, for which the status&#39; are shown.';
      }
    },
    secondBody() {
      if (this.isCalculatorApplicant) {
        return undefined;
      }

      return 'Quote Number: ' + (this.scoreboard?.quoteDetails?.milesQuoteRef || this.scoreboard?.quoteDetails?.erpQuoteRef || '');
    },
    step() {
      if (this.currentStatus == 'approvals') return 1;
      else if (this.currentStatus == 'reviewAndSignContract') return 2;
      else if (this.currentStatus == 'finished') return 3;
      return 0;
    },
    isHomePage: function () {
      const pathName = this.$route.path;
      return pathName === `/applications/${this.applicationId}`;
    }
  },
  mounted() {
    if (!this.scoreboard) this.$router.push({ name: 'error' });
  },
  components: { QBtn, ProgressList, MainHeadline, ProgressSteps },
  data: function () {
    return {
      loading: false
    };
  },
  methods: {
    approvalsStatus: function () {
      switch (this.currentStatus) {
        case 'approvals':
          return 'progress';
        case 'reviewAndSignContract':
          return 'completed';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    reviewSignContrctStatus: function () {
      switch (this.currentStatus) {
        case 'approvals':
          return 'pending';
        case 'reviewAndSignContract':
          return 'progress';
        case 'finished':
          return 'completed';
        default:
          return 'pending';
      }
    },
    onClickHandler: async function () {
      this.loading = true;
      if (this.approvalsStatus() == 'pending') {
        await this.updateVehicleApplication('approvals', 'statusSecondary');
        this.$router.push({ name: 'approvals' });
      } else if (this.approvalsStatus() == 'progress') {
        this.$router.push({ name: 'approvals' });
      } else if (this.reviewSignContrctStatus() == 'progress') {
        this.$router.push({ name: 'reviewAndSignContract' });
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="sass" scoped>
hr
  border: 0;
  border-top: 1px solid #EEEEEE;
.header
  padding: 50px 0 0;
  text-align: center;
  background-color: #E9F3FE;
  background-image: url('/assets/icons/header-background.svg');
  background-position: center top;
  background-repeat: no-repeat;
  min-height: 350px;
.header-logo
  width: 95%;
  max-width: 400px;
</style>
